skrilla.directive('checkboxes', function () {
  return {
    templateUrl: 'directives/checkboxes/checkboxes.html',
    scope: {
      items: "=",
      labels: "="
    },
    link: function ($scope) {
      $scope.$watch("items", function (newVal, oldVal) {
        if (newVal) {
          $scope.items = newVal
          $scope.itemCount = Object.keys($scope.items).length;
        }
      }, true);

      $scope.itemCount =$scope.items ? Object.keys($scope.items).length : 0;

      const checkedCount = function () {
        return $scope.items ? Object.values($scope.items).filter(value => value ).length : 0;
      };

      $scope.isIndeterminate = function() {
        return (checkedCount() !== 0 && checkedCount() !== $scope.itemCount);
      };

      $scope.isChecked = function() {
        return (checkedCount() === $scope.itemCount);
      };

      $scope.toggleAll = function() {
        const value = checkedCount() !== $scope.itemCount;
        Object.keys($scope.items).forEach(
          key =>  { $scope.items[key] = value }
        );
      };
    }
  };
});
